export default "__VITE_ASSET__ChlNR28P__"